import { css } from '@emotion/react';

export const drawerFormStyles = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;
